<h6>{{ connection?.Namespace }} Queues</h6>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="false"
  [sortable]="false"
  [filterable]="false"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true">

    <kendo-grid-column
        field="Id"
        title="ID"
        width="100"
        [editable]="false"
        [hidden]="true">
    </kendo-grid-column>

    <kendo-grid-column
        field="ConnectionId"
        title="Connection Id"
        width="100"
        [editable]="false"
        [hidden]="true">
    </kendo-grid-column>

    <kendo-grid-column
        field="Name"
        title="Name"
        width="40%">
    </kendo-grid-column>

    <kendo-grid-column
        field="IsActive"
        title="Active"
        width="15%">
    </kendo-grid-column>

    <kendo-grid-column
        field="MaxSize"
        title="Max Size (Mb)"
        width="20%">
    </kendo-grid-column>

    <kendo-grid-column
        field="IsPartitioned"
        title="Partitioned"
        width="15%">
    </kendo-grid-column>

    <kendo-grid-command-column title="" width="10%">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <button class="btn btn-primary compact-button" kendoGridEditCommand>
            <fa-icon icon="external-link-alt"></fa-icon>
          </button>
        </ng-template>
    </kendo-grid-command-column>

</kendo-grid>

<app-queue 
    [model]="editItem"
    [connection]="connection"
    (cancel)="cancelHandler()">
</app-queue>

